<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="tips">
          <el-page-header
            @back="goBack"
            :content="`师徒沟通 ${list.total_count ? list.total_count : 0}次`"
          ></el-page-header>
        </div>
      </div>
      <div class="search">
        <el-input
          v-model="query.keyword"
          placeholder="请输入搜索关键字"
          suffix-icon="el-icon-search"
          @change="
            query.pageIndex = 1;
            initData();
          "
        >
        </el-input>
      </div>
    </div>

    <section class="uc-examList">
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div v-for="(item, index) in list.items" :key="index" class="item">
        <div class="title">
          <div class="c el-icon-chat-dot-round">
            {{ item.title }}
          </div>
        </div>

        <div class="con">
          <div class="sub-item w50">
            <i class="el-icon-s-custom"></i> 师傅：{{ item.master_name }}
          </div>
          <div class="sub-item w50">
            <i class="el-icon-time"></i> 沟通日期：{{ item.date.substr(0, 10) }}
          </div>
          <div class="sub-item w100">
            <i class="el-icon-place"></i> 沟通地点：{{ item.address }}
          </div>
          <div
            v-bind:class="{ expansion: item.is_long_content }"
            class="sub-item w100"
            v-html="`<i class=el-icon-document></i> 沟通内容：${item.content}`"
          ></div>
          <el-button
            type="text"
            v-if="item.is_show_btn"
            v-on:click="item.is_long_content = !item.is_long_content"
          >
            <span
              v-html="
                item.is_long_content
                  ? '展开<i class=el-icon-arrow-down></i>'
                  : '收起<i class=el-icon-arrow-up></i>'
              "
            >
            </span>
          </el-button>
        </div>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'MasterCommunication',
  data() {
    return {
      query: {
        type: 1,
        apprenticeId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      list: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getShituCommunications();
    },
    async getShituCommunications() {
      const response = await this.$api.shitu.getShituCommunications(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
    // 返回上一层
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
